import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class ChecklistService {

  constructor(private http: HttpClient) {
  }

  getCheckList() {
    return this.http.get<any>(urls.BASE_URL + urls.CHECK_LIST_SPACE_TYPES)
      .pipe(
        catchError(errorHandl)
      );
  }

  getCheckListById(id){
    return this.http.get<any>(urls.BASE_URL + urls.CHECK_LIST_SPACE_TYPES + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }
  getCheckListByAssignId(queryParams){
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.TRIP_CHECK_LIST, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  addCheckList(payload,checkListId) {
    if(checkListId){
      return this.http.put<any>(urls.BASE_URL + urls.CHECK_LIST_SPACE_TYPES + `/${checkListId}`, payload)
        .pipe(
          catchError(errorHandl)
        );
    }else {
      return this.http.post<any>(urls.BASE_URL + urls.CHECK_LIST_SPACE_TYPES, payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

}
